  <template>
  <div id="users">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <a
              href="javascript:;"
              class="navbar-nav-link"
              @click="modalVisible = true"
            >
              {{this.$t('event.buttons.authGroups')}}
              <i class="el-icon-unlock ml-1"></i>
            </a>
          </li>
        </ul>
      </portal>
      <div class="content animated fadeIn">
        <div class="card border-bottom-info rounded-bottom-0">
          <div class="card-body">
            <template v-if="$i18n.locale == 'tr'">
              Etkinliğinize yeni kullanıcılar yetkilendirmek için burayı
              kullanabilirsiniz, yetkilendirmek istediğiniz kullanıcının
              <strong>e-posta adresini</strong> girdikten sonra
              <strong>yetki grubunu seçip</strong>
              ardından yetkilendir butonuna basınız.
            </template>

            <template v-else>
              You can use here to authorize new users to your event, enter the
              <strong>email address</strong> of the user you want to authorize,
              <strong>select the authorization group</strong>, and then click
              the Authorize button.
            </template>

            <div class="form-group row mt-3 mb-0">
              <label class="col-form-label col-lg-2">{{
                this.$t("event.tags.mail")
              }}</label>
              <div class="col-lg-10">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <el-input
                        :placeholder="$t('event.textbox.use')"
                        v-model="email"
                      ></el-input>
                      <span class="error">
                        {{ $errorMessage("email", validationErrors) }}
                      </span>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <el-select
                        v-model="groupID"
                        :placeholder="$t('event.textbox.selectAuth')"
                      >
                        <el-option
                          v-for="item in $store.state.users.groups"
                          :key="item.id"
                          :label="item.title"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                      <span class="error">
                        {{ $errorMessage("roleGroupID", validationErrors) }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <el-button type="primary" @click="addUser">{{
                      $t("event.buttons.authorize")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card" style="padding: 0px; box-shadow: unset">
          <div
            class="card-header header-elements-inline"
            style="padding-bottom: 0px"
          >
            <h5 class="card-title">
              {{ this.$t("event.menu.eventusers.title") }}
            </h5>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('event.buttons.helpdesk')"
                  placement="top"
                >
                  <el-button
                    @click="$helpMe(null)"
                    icon="fas fa-life-ring"
                    size="mini"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('event.buttons.refresh')"
                  placement="top"
                >
                  <el-button
                    icon="fas fa-redo-alt"
                    size="mini"
                    @click="$store.dispatch('getUsers')"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <el-table
            v-loading="$store.state.users.loading"
            ref="multipleTable"
            :data="$store.state.users.items"
            style="width: 100%"
          >
            <el-table-column :label="$t('event.table.user')" property="title" min-width="200">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.userDetail != null"
                  style="display: block; font-weight: bold"
                  >{{ scope.row.userDetail.firstName }} {{ scope.row.userDetail.lastName }} </span
                >
                <span v-if="scope.row.userDetail != null">{{
                  scope.row.userDetail.email
                }}</span>
                <span v-if="scope.row.userDetail == null">{{
                  scope.row.email
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('event.buttons.authGroup')"
              property="title"
              min-width="200"
            >
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.userDetail != null &&
                    scope.row.userDetail.role == 1
                  "
                  >{{$t('mainUser')}}</span
                >
                <span v-else>{{
                  $store.state.users.groups.find(
                    (k) => k.id == scope.row.organizationRoleGroupID
                  ).title
                }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('event.table.status')" property="title" min-width="200">
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.userDetail != null &&
                    scope.row.invitationConfirmed == true
                  "
                  >{{ $t("event.tags.active") }}</span
                >
                <span
                  v-if="
                    scope.row.userDetail == null &&
                    scope.row.invitationConfirmed == false &&
                    $moment(scope.row.expireDate).isBefore($moment())
                  "
                  >{{$t('prescription')}}</span
                >
                <span
                  v-if="
                    scope.row.userDetail == null &&
                    scope.row.invitationConfirmed == false &&
                    $moment(scope.row.expireDate).isBefore($moment()) == false
                  "
                  >{{$t('event.tags.pending')}}</span
                >
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              :label="$t('event.table.processes')"
              width="150"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('event.buttons.sendAgain')"
                  placement="top"
                >
                  <el-popconfirm
                    v-if="
                      scope.row.userDetail == null &&
                      scope.row.invitationConfirmed == false &&
                      $moment(scope.row.expireDate).isBefore($moment())
                    "
                    @confirm="reSend(scope.row)"
                    :confirmButtonText="$t('event.variables.yes')"
                    :cancelButtonText="$t('event.buttons.cancel')"
                    icon="el-icon-info"
                    iconColor="red"
                    :title="$t('reInvite')"
                  >
                    <el-button
                      slot="reference"
                      type="success"
                      icon="el-icon-refresh"
                      circle
                      size="mini"
                    ></el-button>
                  </el-popconfirm>
                </el-tooltip>

                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('event.table.delete')"
                  placement="top"
                  v-if="scope.row.role != 1"
                >
                  <el-popconfirm
                    @confirm="deleteItem(scope.$index)"
                    :confirmButtonText="$t('event.variables.yes')"
                    :cancelButtonText="$t('event.buttons.cancel')"
                    icon="el-icon-info"
                    iconColor="red"
                    :title="$t('event.textbox.toDelete')"
                  >
                    <el-button
                      slot="reference"
                      type="danger"
                      icon="fas fa-trash"
                      circle
                      size="mini"
                    ></el-button>
                  </el-popconfirm>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="modalVisible"
      :title="$t('event.buttons.authGroups')"
      width="78%"
      :append-to-body="true"
    >
      <RoleGroups @closeMe="modalVisible = false" />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import PageCountInfo from "./PageCountInfo";
import RoleGroups from "./RoleGroups";
import $ from "jquery";
export default {
  components: { PageCountInfo, RoleGroups },
  name: "Users",
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "questionlibrary",
      email: null,
      groupID: null,
      validationErrors: [],
    };
  },
  methods: {
    reSend(item) {
      axios
        .post("user/resendinvitation", {
          id: item.id,
        })
        .then((res) => {
          this.$store.dispatch("getUsers");

          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
          }
        });
    },
    handleSizeChange(take) {
      this.$store.commit("setUsersTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setUsersPage", page);
    },
    itemUpdated(item) {
      console.log('tetiklendi 1')

      this.$store.dispatch("getUsers");
    },
    itemAdded(item) {
      console.log('tetiklendi 2')
      
      this.$store.dispatch("getUsers");

    },
    deleteItem(index) {
      console.log('tetiklendi 3')
      this.$store.dispatch("deleteUser", { index, context: this });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleUsers", { index, value });
    },
    addUser() {
      axios
        .post("user/add", {
          email: this.email,
          roleGroupID: this.groupID,
        })
        .then((res) => {
          this.validationErrors = res.data.validationErrors;
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
            this.email = null;
            this.groupID = null;
            this.$store.dispatch("getUsers");
          }
        });
    },
  },
  mounted() {
    this.$store.dispatch("getUsers");
    this.$store.dispatch("getUserGroups");
  },
  created() {},
  computed: {
    skip() {
      return (
        (this.$store.state.users.filter.page - 1) *
        this.$store.state.users.filter.take
      );
    },
    take() {
      return 100;
    },
  },
  watch: {
    "$store.state.users.filter.searchTerm": function () {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getUsers");
      }, 500);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Users.vue